import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { ProductPriceTierSelector } from "../../product/price-tier/components/selector";

class Selector extends React.Component {
    state = { selected: null };
    isPopup() {
        return false;
    }
    getValue() {
        return this.state.selected;
    }
    render() {
        const { data, productPriceTiers } = this.props;
        return (
            <div style={{ width: 300 }}>
                <ProductPriceTierSelector
                    open
                    search
                    fluid
                    clearable={false}
                    priceTiers={productPriceTiers}
                    value={this.state.selected || parseInt(data?.product_price_tier_id)}
                    onChange={(_, { value }) => {
                        const newData = {
                            ...this.props.node.data,
                            // Need to update this because the renderer gets the value from this prop
                            // the product_price_tier_id is not used for display
                            productPriceTier: productPriceTiers.find(({ id }) => id === value),
                            product_price_tier_id: value,
                        };
                        this.props.node.setData(newData);
                        this.setState({ selected: value }, () => this.props.stopEditing());
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ auth }) => ({
    productPriceTiers: auth.user.company?.productPriceTiers?.sort(
        (a, b) => b.is_base_tier - a.is_base_tier
    ),
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export const GridProductPriceTierSelector = connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(Selector);
